import styled from "styled-components"

export default {
    "Footer": styled.footer`
        position: fixed;
        bottom: 0;
        left: 0;
        display: flex;
        align-items: center;
        height: 62px;
        background-color: ${({ theme }) => theme.color["grey1"]};
        z-index: 2;
    `,

    "MenuElement": styled.div`
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 3px;
        cursor: pointer;

        & > img {
            width: 20px;
        }
        
        & > p {
            ${({ theme, $active }) => $active
            ? theme.font["small-bold"]
            : theme.font["small-medium"]
        };
            color: ${({ theme, $active }) => $active
            ? theme.color["black"]
            : theme.color["grey4"]
        };
        }
    `,
}